<section
  class="min-h-[80vh] w-full grid place-items-center px-6 py-12 "
>
  <div class="w-full max-w-xl text-center">
    <div
      class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-red-50 ring-1 ring-red-100 shadow-sm"
    >
      <i class="fas fa-lock fa-2x text-dc-commerce-red"></i>
    </div>

    <h1
      class="text-3xl font-semibold tracking-tight text-dc-navy"
    >
       {{ "UNAUTHORIZED" | translate}}
    </h1>

    <p class="mt-3 text-base text-gray-600 dark:text-gray-300">      
      {{ "NO_PERMISSION" | translate}}
    </p>

    <div class="mt-8 flex flex-wrap items-center justify-center gap-3">
     
      <app-button
          [type]="'button'"
          [label]="'BUTTONS.SIGN_IN' | translate"
          classesName="btn-edge-cut  btn-width-auto"
          (onBtnClick)="goToLogin()"
        />

       <app-button
          [type]="'button'"
          [label]="'BUTTONS.BACK_HOME' | translate"
          classesName="btn-edge-cut card-edge-cut-white btn-width-auto"
          (onBtnClick)="goHome()"
        />
    </div>
  </div>
</section>
